import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import Vision from "./sections/Vision";
import Values from "./sections/Values";
import Partners from "./sections/Partners";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Vision />
      <Values />
      <Partners />
      <Footer />
    </div>;
}